import React from "react";
import {
  makeStyles,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  useMediaQuery,
} from "@material-ui/core";
import { BATTLEPASSES_ORDERED, SEASONS_ORDERED, LTMS } from "../../types";

export default ({ userData, totalPacks, heirloomRecord }) => {
  const useStyles = makeStyles({
    th: {
      fontWeight: 900,
    },
    totalRow: {
      backgroundColor: "#333",
    },
    totalRowDivider: {
      backgroundColor: "#333",
      borderTop: "3px solid #777",
    },
    subtotalCell: {
      fontWeight: 400,
    },
    totalCell: {
      fontWeight: 900,
    },
    card: {
      marginTop: "1.5rem",
    },
  });
  const {
    accountPacks,
    seasonalPacks,
    miscPacks,
    twitchPrime,
    purchasedPacks,
    seasonalQuestPacks,
    seasonalLTMs,
  } = userData;
  const mqBelow600 = useMediaQuery("(max-width: 600px)");
  const classes = useStyles();

  const createRow = (activity, packs) => {
    return { activity, packs };
  };

  const rows = [createRow(`Account`, accountPacks)];

  if (!!twitchPrime) {
    rows.push(createRow(`Twitch Prime`, 5));
  }

  BATTLEPASSES_ORDERED.forEach((thisSeason, i) => {
    if (i === 0) return; // skip season 0 preseason

    // [seasonalPacks]
    if (!!seasonalPacks[i]) {
      rows.push(
        createRow(`Season ${i}: ${SEASONS_ORDERED[i].NAME}`, seasonalPacks[i])
      );
    }

    // [seasonalQuestPacks]
    if (!!seasonalQuestPacks[i]) {
      rows.push(
        createRow(
          SEASONS_ORDERED[i].QUEST === "treasurePacks"
            ? `S${i} Treasure Packs`
            : `S${i} Quest: ${SEASONS_ORDERED[i].QUEST}`,
          seasonalQuestPacks[i]
        )
      );
    }

    // [seasonalLTMs]
    if (!!seasonalLTMs[i]) {
      seasonalLTMs[i].forEach((thisLTM, j) => {
        if (!!thisLTM)
          rows.push(createRow(LTMS[i][j].name, seasonalLTMs[i][j]));
      });
    }
  });

  if (!!purchasedPacks) {
    rows.push(createRow(`Purchases`, purchasedPacks));
  }

  if (!!miscPacks) {
    rows.push(createRow(`Misc + Bugs`, miscPacks));
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table size={mqBelow600 ? "small" : "medium"}>
          <TableHead style={{ backgroundColor: "#505050" }}>
            <TableRow>
              <TableCell classes={{ root: classes.th }}>Activity</TableCell>
              <TableCell classes={{ root: classes.th }}>Apex Packs</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.activity}>
                <TableCell component="th" scope="row">
                  {row.activity}
                </TableCell>
                <TableCell>{row.packs}</TableCell>
              </TableRow>
            ))}
            <TableRow
              key="subtotal-packs"
              classes={{ root: classes.totalRowDivider }}
            >
              <TableCell classes={{ root: classes.totalCell }}>
                {heirloomRecord === null ? "Total" : "Subtotal"}
              </TableCell>
              <TableCell classes={{ root: classes.totalCell }}>
                {totalPacks}{" "}
                {heirloomRecord === null &&
                  `(${Math.round((totalPacks / 500) * 100)}%)`}
              </TableCell>
            </TableRow>

            {heirloomRecord !== null && (
              <>
                <TableRow
                  key="previous-packs"
                  classes={{ root: classes.totalRow }}
                >
                  <TableCell classes={{ root: classes.subtotalCell }}>
                    Applied to Previous Heirlooms
                  </TableCell>
                  <TableCell classes={{ root: classes.subtotalCell }}>
                    -{heirloomRecord}
                  </TableCell>
                </TableRow>
                <TableRow
                  key="total-packs"
                  classes={{ root: classes.totalRow }}
                >
                  <TableCell classes={{ root: classes.totalCell }}>
                    TOTAL
                  </TableCell>
                  <TableCell classes={{ root: classes.totalCell }}>
                    {totalPacks - heirloomRecord} (
                    {(((totalPacks - heirloomRecord) / 500) * 100).toFixed(1)}
                    %)
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
